import React from 'react';
import {Link} from 'react-router';

class HomePage extends React.Component {

    render() {
        return (
            <div>
                <h1>Tableau de bord</h1>
                <p>Bientôt disponible... Si vous avec des recommandations et/ou des idées vous pouvez les soumettre sur le channel slack #dashboard.</p>
            </div>
        );
    }

}

export default HomePage;


/** WEBPACK FOOTER **
 ** ./src/components/home/HomePage.js
 **/